import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CustomersTable from './customers-table.jsx';

if (document.getElementById(
  'react-component-g4-logistics-portal-all-pending-customers')) {
  ReactDOM.render(
    <CustomersTable
      message_if_none = 'No Customers found. Add one to see it here.'
      url = '/api/v1/portal/customers/all/for-current-user/pending-with-uninvoiced-jobs'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-all-pending-customers'
    )
  );
}